import {
  Box,
  Button,
  Divider,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  FormControlLabel,
  MenuItem,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useToast } from 'use-toast-mui';
import AnimationPage from '../../pages/AnimationPage';
import { errorMessages } from '../../utils/methods';
import CustomCheckbox from '../CustomCheckbox';
import CustomRadioBox from '../CustomRadioBox';
import { FormInputDropdown } from '../form/FormInputDropdown';
import { useForm } from 'react-hook-form';
import { getAllNotices, deleteNoticeById, sendNoticeById } from '../../api/notice';
import { FormInputText } from '../../form-components/FormInputText';
import BannerDeleteModal from '../banner/BannerDeleteModal';

var qs = require('qs');

const Event = () => {
  const { t } = useTranslation();
  const token = useSelector(function (state) {
    return state.user.user.token;
  });
  const user = useSelector(state => state.user.user);
  const initialQuery = {
    page: 1,
    limit: 10,
    title: '',
    headBranchId: user.headBranch?.headBranchId,
    branchId: user.branch?.branchId,
  };

  const toast = useToast();
  const [list, setList] = useState([]);
  const [query, setQuery] = useState(initialQuery);
  const [statusType, setStatusType] = useState(true);
  const [ids, setIds] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [open, setOpen] = useState(false);
  const { handleSubmit, control, reset, watch, getValues, setValue } = useForm({ defaultValues: initialQuery });
  const navigate = useNavigate();
  const getList = async () => {
    const queryString = qs.stringify(query);
    try {
      const data = await getAllNotices(queryString, token);
      setList(data);
    } catch (error) {
      console.error('API call failed:', error);
      toast.error(errorMessages(error));
    }
  };

  const handleChange = id => {
    setIds(prevIds => {
      // Check if the id already exists in the array
      if (prevIds.includes(id)) {
        // If it exists, remove it (filter it out)
        return prevIds.filter(existingId => existingId !== id);
      } else {
        // If it doesn't exist, add it to the array
        return [...prevIds, id];
      }
    });
  };

  const handleAllSelect = () => {
    setCheckAll(!checkAll);

    if (!checkAll) {
      // Select all items
      setIds(list?.content?.map(el => el.noticeId));
    } else {
      // Deselect all items
      setIds([]);
    }
  };

  const handleChangePage = (_, value) => {
    setQuery({ ...query, page: value });
  };

  const handleDeleteList = async () => {
    if (!ids.length) return;

    try {
      const deletePromises = ids.map(id => deleteNoticeById(id, token));
      await Promise.all(deletePromises);

      toast.success(t('Notice(s) Deleted'));

      getList();
      setIds([]);
    } catch (err) {
      console.log(err);
      toast.error(errorMessages(err));
    }
  };

  const sendNotice = async (e, id) => {
    e.stopPropagation();
    try {
      await sendNoticeById(id, token);
      toast.success(t('Notice(s) SENT'));
      getList();
    } catch (error) {
      console.error('API call failed:', error);
      toast.error(errorMessages(error));
    }
  };

  useEffect(() => {
    setQuery(prevValues => {
      return { ...prevValues, position: getValues('position') };
    });
  }, [watch('position')]);

  useEffect(() => {
    // if (userBranch?.branchId) {
    setQuery(prevQuery => ({
      ...prevQuery,
      headBranchId: user.headBranch?.headBranchId,
      branchId: user.branch?.branchId,
    }));
    // }
  }, [user]);

  useEffect(() => {
    getList();
  }, [query]);

  return (
    <AnimationPage>
      <Box
        component={Paper}
        elavation={2}
        sx={{
          background: '#fff',
          borderRadius: '10px',
          padding: '30px 40px',
          width: '1080px',
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500 }}>
              {t('Search')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '375px' }}
              size="small"
              placeholder="내용을 입력해주세요"
              id="outlined-search"
              type="search"
              name="title"
              control={control}
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  setQuery(prevValues => {
                    return { ...prevValues, title: getValues('title') };
                  });
                }
              }}
            />
            <Button
              onClick={() => {
                setQuery(prevValues => {
                  return { ...prevValues, title: getValues('title') };
                });
              }}
              sx={{
                ml: '4px',
                background: '#0F7F85',
                color: 'white',
                width: '62px',
                height: '36px',
                '&:hover': {
                  color: 'white',
                  background: '#707070',
                },
              }}
              variant="text">
              {t('Search')}
            </Button>
          </Box>
        </Box>
        <Divider sx={{ mb: '20px', mt: '26px', color: '#e1e1e1' }} />
        <TableContainer sx={{ border: '1px solid #ddd' }}>
          <Table sx={{ minWidth: 550 }} size="small" aria-label="a dense table">
            <TableHead sx={{ background: '#fafbfc' }}>
              <TableRow>
                <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                  <CustomCheckbox color="primary" onChange={handleAllSelect} checked={checkAll} />
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #ddd',
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  align="center">
                  {t('Display')}
                </TableCell>
                <TableCell align="center" sx={{ fontSize: '12px', fontWeight: 500, borderRight: '1px solid #ddd' }}>
                  {t('Title')}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderRight: '1px solid #ddd',
                    fontSize: '12px',
                    fontWeight: 500,
                  }}>
                  {t('Published Date')}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  align="center">
                  {t('Position')}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.content?.map((row, index) => (
                <TableRow
                  key={index}
                  onClick={() => navigate(`/notice/${row?.noticeId}`)} // Navigate to the detail page on row click
                  sx={{
                    cursor: 'pointer', // Add a pointer cursor to indicate it's clickable
                    textDecoration: 'none',
                    '&:last-child td, &:last-child th': { borderBottom: 0 },
                    '&:hover': { background: '#f0f0f0' }, // Optional hover effect for better UX
                  }}>
                  <TableCell align="center" padding="checkbox" sx={{ borderRight: '1px solid #ddd' }}>
                    <CustomCheckbox
                      color="primary"
                      name="selectedBanners"
                      checked={ids.includes(row?.noticeId)}
                      onClick={e => e.stopPropagation()} // Stop propagation to avoid row click trigger
                      onChange={() => handleChange(row?.noticeId)}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {t(row?.status)}
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {row?.title}
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {row?.registeredDate}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={e => sendNotice(e, row?.noticeId)}
                      sx={{
                        p: '12px 25px',
                        borderRadius: '5px',
                        height: '36px',
                        background: row?.status === 'CREATED' ? '#0F7F85' : '#98A6AD',
                        color: '#fff',
                        '&:hover': { background: row?.status === 'CREATED' ? '#0F7F85' : '#ddd', color: '#fff' },
                      }}>
                      {row?.status === 'CREATED' ? t('Send Notice') : t('Sent completed')}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <BannerDeleteModal open={open} setOpen={setOpen} handleDelete={handleDeleteList} />
        <Box
          sx={{
            display: 'flex',
            mt: '10px',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}>
          <Button
            onClick={() => setOpen(true)}
            sx={{
              p: '12px 37px 11px 37px',
              borderRadius: '5px',
              height: '36px',
              width: '100px',
              background: '#98A6AD',
              color: '#fff',
              '&:hover': { background: '#ddd' },
            }}>
            {t('Delete')}
          </Button>
          <Stack spacing={1}>
            <Pagination
              count={Math.ceil(list?.totalElements / query.limit) || 0}
              onChange={handleChangePage}
              page={query.page}
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium': {
                  background: '#0F7F85',
                  border: 'none',
                  height: '24px',
                  minWidth: '24px',
                },
                '& .MuiPaginationItem-root.MuiPaginationItem-sizeMedium.Mui-selected': {
                  background: '#0F7F85',
                  color: '#fff',
                },
                '.MuiPaginationItem-icon': {
                  color: '#fff',
                },
              }}
            />
          </Stack>
          <Link to="/notice/create">
            <Button
              sx={{
                p: '12px 56px 11px 55px',
                borderRadius: '5px',
                height: '36px',
                width: '137px',
                background: '#0F7F85',
                color: '#fff',
                '&:hover': { background: '#0F7F85', color: '#fff' },
              }}>
              {t('Create')}
            </Button>
          </Link>
        </Box>
      </Box>
    </AnimationPage>
  );
};

export default Event;
